// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"45dcc3f6","201":"03311582","405":"bffae2b8","950":"03311582"}[chunkId] + ".chunk.css";
};